import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

const app = createApp(App)

// 注意顺序：先使用 router 和 store，再挂载
app.use(router)
app.use(store)
app.mount('#app')

if (process.env.NODE_ENV === 'development') {
  // 开发环境禁用严格SSL
  process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
}
